export const WarehouseNavIcon = () => {
  return (
    <svg width="34" height="25" viewBox="0 0 34 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.5 12.6641H31.5002M31.5002 12.6641L27.5002 7.66406M31.5002 12.6641L27.5002 17.6641M3.5 12.6641H6M8.5 12.6641H11"
        stroke="#222530"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
